/*
Application Name: Practice Aid.
Application URI: https://practice-aid.com/
Description: PracticeAid is a group of professionals with collective expertise in medical and dental science, hospital administration and software development. These experts have come together to work on path-breaking solutions in Healthcare IT and deliver tangible value.
Version: 1.0.0
Author: Practice Aid.
Author URI: https://practice-aid.com/
 “M/s Totall Practice Aid Private Limited, CIN U72900MP2022PTC059139”
*/
import { postRequestWithToken } from "./helper"


export const addTreatmentType = (data) => postRequestWithToken(data, 'admin/add-treatment-type');
export const updateTreatmentType = (data) => postRequestWithToken(data, 'admin/update-treatment-type');
export const changeTreatmentTypeStatus = (data) => postRequestWithToken(data, 'admin/treatment-type-change-status');
export const treatmentTypeList = (data) => postRequestWithToken(data, 'admin/treatment-type-list');
